import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { styled } from '@abyss/web/tools/styled';
import { formFormatterRegex } from '../../../resources/formFormatterRegex';

const StyledTextInput = styled(TextInput, {
  'input::-webkit-contacts-auto-fill-button': {
    visibility: 'hidden',
    display: 'none !important',
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
  },
});

export const Name = () => {
  const { notAllowNumeric } = formFormatterRegex;
  const { modelPrefix, onBlur } = usePropsContext();

  return (
    <StyledTextInput
      data-testid="name"
      label="Name"
      model={`${modelPrefix}.name`}
      subText="Wildcard search (*) available on partial name search."
      descriptorsDisplay="column"
      maxLength={50}
      isClearable
      width="50%"
      formatter={value => {
        return value.replace(notAllowNumeric, '');
      }}
      validators={{
        required: 'Please enter a value',
        validate: {
          wildCard: v =>
            v.includes('*') && !v.endsWith('*')
              ? 'Wild card must be at the end of the name'
              : true,
          wildCardLength: v =>
            v.includes('*') && v.length < 5
              ? 'A minimum of 4 alphanumeric character(s) is required for name when using a wild card'
              : true,
        },
      }}
      onBlur={() => onBlur(`${modelPrefix}.name`)}
    />
  );
};
